import React from 'react';

export const Footer = () => {
    return (
        <div className="footer text-center copyright">
            Copyright &copy; 2021 &mdash; Ooredoo
        </div>
    );
}